import { Link, useRouteError, isRouteErrorResponse } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { isRouteModuleLoadError } from "@/lib/route-module-recovery"

export function RouteError({ notFound = false }: { notFound?: boolean }) {
  const error = useRouteError()
  const is404 = notFound || (isRouteErrorResponse(error) && error.status === 404)
  const isModuleError = isRouteModuleLoadError(error)

  const title = is404 ? "Página no encontrada" : "Algo salió mal"
  const message = is404
    ? "La página que buscas no existe o fue movida."
    : isModuleError
      ? "No se pudo cargar esta sección. Recarga la página para intentarlo de nuevo."
      : "Ocurrió un error inesperado. Intenta de nuevo."

  if (!is404 && error) {
    // Surface real errors to the console for debugging.
    console.error("[RouteError]", error)
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-background p-6 text-center">
      <h1 className="text-4xl font-bold text-foreground">{is404 ? "404" : "Error"}</h1>
      <h2 className="text-xl font-semibold text-foreground">{title}</h2>
      <p className="max-w-md text-muted-foreground">{message}</p>
      <div className="flex flex-wrap justify-center gap-3">
        {!is404 && <Button onClick={() => window.location.reload()}>Recargar página</Button>}
        <Button asChild variant={is404 ? "default" : "outline"}>
          <Link to="/">Volver al inicio</Link>
        </Button>
      </div>
    </div>
  )
}
